var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromotionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.547 15.4401L16.547 3.44008C16.067 2.96008 15.4003 2.66675 14.667 2.66675H5.33366C3.86699 2.66675 2.66699 3.86675 2.66699 5.33341V14.6667C2.66699 15.4001 2.96033 16.0667 3.45366 16.5601L15.4537 28.5601C15.9337 29.0401 16.6003 29.3334 17.3337 29.3334C18.067 29.3334 18.7337 29.0401 19.2137 28.5467L28.547 19.2134C29.0403 18.7334 29.3337 18.0667 29.3337 17.3334C29.3337 16.6001 29.027 15.9201 28.547 15.4401ZM7.33366 9.33341C6.22699 9.33341 5.33366 8.44008 5.33366 7.33341C5.33366 6.22675 6.22699 5.33341 7.33366 5.33341C8.44033 5.33341 9.33366 6.22675 9.33366 7.33341C9.33366 8.44008 8.44033 9.33341 7.33366 9.33341Z",
    fill: "#ECECEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotionIcon);
export default __webpack_public_path__ + "static/media/promotionIcon.b3d42c9418469f7a9412e93ef6f75e40.svg";
export { ForwardRef as ReactComponent };